<template>
    <div class="checkbox-container" @click="change">
        <div class="checkbox-itself" :class="[{'checked' : is_true}, {white: whiteCheck}]"></div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        components: {},
        name: 'CheckBox',
        props: ['value', 'whiteCheck'],
        data() {
            return {}
        },
        computed: {
            is_true() {
                if (!Array.isArray(this.value)) {
                    return this.value;
                }
                return this.value.includes(this.$attrs.value);
            }
        },
        methods: {
            change() {
                if (!Array.isArray(this.value)) {
                    this.$emit('input', !this.value);
                } else {
                    let index = this.value.indexOf(this.$attrs.value);
                    if (index >= 0) {
                        this.$emit('input', this.value.filter(item => item != this.$attrs.value));
                    } else {
                        let ret = this.value.map(e => e);
                        ret.push(this.$attrs.value);
                        this.$emit('input', ret);
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .checkbox-container {
        cursor: pointer;
        margin: 5px 2px 2px;
        display: flex;
        white-space: nowrap;
        align-items: center;
    }

    .checkbox-itself {
        display: block;
        float: left;
        flex-shrink: 0;
        height: 13px;
        width: 13px;
        position: relative;
        bottom: 2px;
        background-color: #ffffff;
        border: 1px solid #767676;
        border-radius: 2.5px;

        &::before {
            content: '';
            position: absolute;
            display: block;
            height: 7px;
            width: 3px;
            top: 0px;
            left: 3px;
            border: 2px solid #301070;
            border-left: 0;
            border-top: 0;
            transition: transform 0.15s ease-in-out;
            transform: rotate(45deg) scale(0);
        }

        &::after {
            content: '';
            position: absolute;
            display: block;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            transition: transform 0.15s ease-in-out;
            height: 8px;
            width: 8px;
            background-color: #301070;
        }

        &.checked {
            &::before {
                transform: rotate(45deg) scale(1);
            }
        }
    }

    .checkbox-itself + * {
        margin-left: 10px;
    }
</style>
